module.exports = __webpack_public_path__ + "img/2012-08-18 17.18.15.cf1366ae.jpg";